export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const truncateMiddle = (
  str: string,
  startLength: number,
  endLength: number = startLength,
) => {
  if (str.length <= startLength + endLength) return str;

  const start = str.substring(0, startLength);
  const end = str.substring(str.length - endLength);
  return `${start}...${end}`;
};
